'use strict';

define('features/ctas/deal.builder.cta',[
  'jquery',
  './cta.types',
  'lib/util/langFromUrl'
], function (
  $,
  ctaTypes,
  langFromUrl
) {
  var __type = ctaTypes['dealBuilder']; // eslint-disable-line dot-notation
  var __defaultUrl = 'https://www.toyota.com/' + (langFromUrl() === 'es' ? 'espanol/' : '') + 'configurator/';
  var __buildUrl = __defaultUrl + '#!/build/step/model/year/';

  var __special = {
    2018: ['avalon', 'avalonhybrid']
  };

  function __specialSeries(year, series) {
    return __special[year] && __special[year].indexOf(series) > -1;
  }

  return function dealBuilder(year, series, $scope) {
    var $ctaScope = $scope || $('body');
    var $ctas = $("a[data-destination='" + __type + "']", $ctaScope);
    var finalPath = year + '/series/' + series;

    if (!$ctas.length) return;
    if (!year || !series) {
      $ctas.each(function () {
        $(this).attr({ target: '_blank', href: __defaultUrl }).data('km', 'km-build-clickout');
      });
      return;
    }

    // this works for now... 2018 avalons are the only vehicles we want to modify...
    if (__specialSeries(year, series)) {
      finalPath = '2019/series/' + series;
    }

    $ctas.each(function () {
      $(this).attr({ target: '_blank', href: __buildUrl + finalPath }).data('km', 'km-build-clickout');
    });
  };
});

